import React from "react";
import {
  useGeneralAssessmentSetting,
  useSubjectListForSubjectAssessmentSetting,
} from "../../../../hooks/useAssessment";
import { Spinner } from "reactstrap";
import { adToBsDate } from "../../../../../../utils/Utils";
import moment from "moment";

const AssessmentDetail = ({ detailPayload }) => {
  const { subjectConfig, loading: isSubjectConfigLoading } =
    useSubjectListForSubjectAssessmentSetting(detailPayload);
  const { generalConfig, loading: isGeneralConfigLoading } =
    useGeneralAssessmentSetting(detailPayload);

  const convertAdToBS = (value) => {
    if (!value) return null;

    return adToBsDate(moment(value).format("YYYY-MM-DD"));
  };

  return (
    <div>
      <div className="arr-heading">
        <h1>Subject Configuration</h1>
      </div>
      <div className="arr-table-container">
        <table className="arr-table">
          <thead>
            <tr>
              <th>Subjects</th>
              <th>Subject Type</th>
              <th>Assessment Date</th>
              <th>Recording Date</th>
              <th>Recording Deadline Date</th>
            </tr>
          </thead>
          <tbody>
            {isSubjectConfigLoading ? (
              <tr>
                <td colSpan={5}>
                  <div className="arr-spinner">
                    <div className="loader">
                      <Spinner size={"md"} color="primary"></Spinner>
                    </div>
                    <div style={{ fontSize: "13px", marginTop: "15px" }}>
                      Please wait !! Processing.....
                    </div>
                  </div>
                </td>
              </tr>
            ) : subjectConfig?.length > 0 ? (
              subjectConfig?.map((item, index) => (
                <React.Fragment key={item.id}>
                  {item.hasTheory && (
                    <tr>
                      <td>{item.name}</td>
                      <td>
                        <div className="arr-badge">Theory</div>
                      </td>
                      <td>
                        <div
                          style={{
                            flexWrap: "nowrap",
                            whiteSpace: "nowrap",
                            gap: "10px",
                          }}
                          className="flex"
                        >
                          <span>
                            {convertAdToBS(item?.assessmentTheoryFromDate) ??
                              "-"}
                          </span>
                          <span>to</span>
                          <span>
                            {convertAdToBS(item?.assessmentTheoryToDate) ?? "-"}
                          </span>
                        </div>
                      </td>
                      <td>{convertAdToBS(item?.recordingTheoryDate) ?? "-"}</td>
                      <td>
                        {convertAdToBS(item?.recordingTheoryDeadlineDate) ??
                          "-"}
                      </td>
                    </tr>
                  )}

                  {item.hasPractical && (
                    <tr>
                      <td>{item.name}</td>
                      <td>
                        <div className="arr-badge">Practical</div>
                      </td>
                      <td>
                        <div
                          style={{
                            flexWrap: "nowrap",
                            whiteSpace: "nowrap",
                            gap: "10px",
                          }}
                          className="flex"
                        >
                          <span>
                            {convertAdToBS(item?.assessmentPracticalFromDate) ??
                              "-"}
                          </span>
                          <span>to</span>
                          <span>
                            {convertAdToBS(item?.assessmentPracticalToDate) ??
                              "-"}
                          </span>
                        </div>
                      </td>
                      <td>
                        {convertAdToBS(item?.recordingPracticalDate) ?? "-"}
                      </td>
                      <td>
                        {convertAdToBS(item?.recordingPracticalDeadlineDate) ??
                          "-"}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="arr-heading">
        <h1>General Configuration</h1>
      </div>
      <div className="arr-table-container">
        <table className="arr-table">
          <thead>
            <tr>
              <th>Assessment From</th>
              <th>Assessment To</th>
              <th>Recording Date</th>
              <th>Deadline Date</th>
            </tr>
          </thead>
          <tbody>
            {isGeneralConfigLoading ? (
              <tr>
                <td colSpan={4}>
                  <div className="arr-spinner">
                    <div className="loader">
                      <Spinner size={"md"} color="primary"></Spinner>
                    </div>
                    <div style={{ fontSize: "13px", marginTop: "15px" }}>
                      Please wait !! Processing.....
                    </div>
                  </div>
                </td>
              </tr>
            ) : generalConfig !== null ? (
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  {convertAdToBS(generalConfig?.assessmentFromDate) ?? "-"}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {convertAdToBS(generalConfig?.assessmentToDate) ?? "-"}
                </td>
                <td>{convertAdToBS(generalConfig?.recordingDate) ?? "-"}</td>
                <td>
                  {convertAdToBS(generalConfig?.recordingDeadlineDate) ?? "-"}
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssessmentDetail;
